import type { BaseTranslation } from "../i18n-types";

const en = {
	WELCOME_LONG: "Welcome to Unicorn Digital Courtroom",
	WELCOME: "Welcome {name:string}!",
	JOIN_ROOM_DESCRIPTION: "Join a room listed below or create your own room!",
	NO_ROOM: "Don't see the room you are looking for? Create your own room.",
	CREATE_ROOM: "Create Room",
	ROOM: "Room",
	ACCESSIBILITY_SETTINGS: "Accessibility Settings",
	ACCESSIBILITY_SETTINGS_DESCRIPTION: "Change accessibility settings here",
	CONTRAST: "Contrast",
	SELECT_DISPLAY_NAME: "Please enter the display name you would like to use",
	SOMETHING_WENT_WRONG: "Uh oh! Something went wrong.",
	GO_BACK: "Go Back",
	GO_BACK_TO_ROOM: "Back to Room",
	EXPAND: "Expand",
	EXPORT: "Export",
	JOIN_ROOM: "Join Room",
	ROOM_ENDED_TITLE: "Room Ended",
	ROOM_ENDED_DESCRIPTION:
		"The room ended, you will be redirected to the home screen",
	RENAME_FAILED: "Rename failed.",
	TRANSCRIPT_DISCLAIMER:
		"A transcript based on the identified speakers. You must speak for more than 7 seconds to be identified.",
	CHANGE_SPEAKER_TITLE: "Change Speaker",
	CHANGE_SPEAKER_DESCRIPTION: "change the speaker name and color here",
	PREVIEW_MESSAGE: "This is a preview message",
	COLOR: "Color",
	NAME: "Name",
	CANCEL: "Cancel",
	LANGUAGE: "Language",
	SAVE: "Save Changes",
	ROOM_ID: "Room ID",
	ROOM_ID_FORM_PLACEHOLDER: "Enter the room ID to join",
	ROOM_ID_FORM_REQUIRED: "Room ID is required to join",
	ROOM_ID_FORM_MIN_LENGTH: "Room ID should be 17 characters",
	LOGIN: "Login",
	ROOM_COL: "Room:",
	LANGUAGE_COL: "Language",
	END_ROOM: "End Room",
	JOIN_NOW: "Join Now",
	LOGIN_FORM: {
		TOAST_TITLE: "Logged in!",
		TOAST_DESCRIPTION: "You can now create/join a room!",
		DISPLAY_NAME: "Display Name",
		DISPLAY_NAME_FORM_PLACEHOLDER: "Enter display name",
		DISPLAY_NAME_FORM_SHORT: "Display name should be at least 3 characters",
		DISPLAY_NAME_FORM_LONG: "Display name should be at most 32 characters",
		DISPLAY_NAME_FORM_REQUIRED: "Display name is required",
	},
	PROFILE_FORM: {
		TITLE: "Complete Your Profile",
		DESCRIPTION: "Please enter your display name to get started",
		TOAST_SUCCESS_TITLE: "Profile Updated!",
		TOAST_SUCCESS_DESCRIPTION: "Your profile has been saved successfully.",
		TOAST_ERROR_TITLE: "Update Failed",
		TOAST_ERROR_DESCRIPTION: "Failed to update your profile. Please try again.",
		SUBMIT_BUTTON: "Save Profile",
	},
	DIARIZATION: {
		UNDETECTED: "Undetected",
		ACCURACY: "Accuracy",
		ID: "ID",
		LEXICAL: "Lexical",
		ITN: "ITN",
		MASKED_ITN: "Masked ITN",
		LANGUAGE: "Language",
		ORIGINAL_TEXT: "Original Text",
		SPEAKER: "Speaker",
	},
	NO_ROOMS_LIST: "Oops, can't find any rooms.",
	SEARCH_FOR_A_ROOM: "Search for a room",
	AUTH_ERROR_DESCRIPTION:
		"There was a problem authenticating you. Please refresh.",
	DELETE_CONFIRMATION_MODAL: {
		TITLE: "Delete Room",
		DESCRIPTION: "Are you sure you want to delete this room?",
		CANCEL: "Cancel",
		DELETE: "Delete",
	},
	CREATE_ROOM_TOAST: {
		TITLE: "Room Created",
		DESCRIPTION: "Your room is ready to join.",
	},
	CREATE_ROOM_FORM: {
		DESCRIPTION: "Set a name for your room for others to see.",
		NAME_LABEL: "Room Name",
		NAME_PLACEHOLDER: "Type Room name",
		LANGUAGE: "Language",
		LANGUAGE_PLACEHOLDER: "Select a language",
		AUTO_DETECT: "Auto-Detect",
		ENGLISH_US: "English (United States)",
		ENGLISH_IN: "English (India)",
		ARABIC_KSA: "Arabic (Saudi Arabia)",
		SPANISH_CR: "Spanish (Costa Rica)",
		CATALAN_ES: "Catalan (Spain)",
		PORTUGUESE_PT: "Portuguese (Portugal)",
		PORTUGUESE_BR: "Portuguese (Brazil)",
		ESTONIAN_EE: "Estonian (Estonia)",
		RUSSIAN_RU: "Russian (Russia)",
		MALTESE_MT: "Maltese (Malta)",
		FILIPINO_PH: "Filipino (Philippines)",
		LANGUAGE_DESCRIPTION:
			"Select a language for the room, you cannot change the room language later.",

		INCPERSONDEFAULT: "Doe,Jane",
		CDCDEFAULT: "AB1234",
		HEARINGTYPEDEFAULT: "Subsequent Suitability Hearing",
		SCHEDULEDEFAULT: "11/28/2023, 10:30 am PST",
		ADVANCED: "Advanced settings",
		INCARCERATED_PERSON_PLACEHOLDER: "Enter your name",
		CDC_PLACEHOLDER: "Enter CDC number",
		HEARING_TYPE_PLACEHOLDER: "Enter hearing type",
		INCARCERATED_PERSON: "Incarcerated person",
		CDC: "CDC",
		HEARING_TYPE: "Hearing Type",
		SCHEDULE: "Schedule",
		PICKDATE: "Pick a date",
		HOURS: "Hours",
		MINUTES: "Minutes",
		SECONDS: "Seconds",
	},
	EXPORT_MODAL: {
		TOAST_FAILED_TITLE: "Export Failed",
		TOAST_FAILED_DESCRIPTION: "Cannot export an empty transcript.",
		DOWNLOAD: "Download",
		DOWNLOAD_DESCRIPTION:
			"Select format for export and enable additional options.",
		SELECT_FORMAT: "Select the format",
		SELECT_FORMAT_PLACEHOLDER: "Select Export format",
		DOCUMENT: "Document (.pdf)",
		SPREADSHEET: "Spreadsheet (.csv)",
		AUDIO: "Audio (.mp3)",
		DOCX: "Word Document (.docx)",
	},
	TRANSLATE_DIALOG: {
		TITLE: "Translation",
		BODY: "Would you like to apply this change to all of this user's transcripts?",
		APPLY_TO_SPEAKER: "Apply To This User Only",
		APPLY_ONCE: "Only Apply Here",
		APPLY_TO_ALL: "Apply To All Users",
		TRANSLATE: "Translate",
	},
	GUEST_FORM: {
		TITLE: "Guest Access",
		DESCRIPTION: "Enter your email address to receive a secure login link",
		EMAIL_LABEL: "Email Address",
		EMAIL_PLACEHOLDER: "Enter email address",
		EMAIL_REQUIRED: "Email address is required",
		EMAIL_INVALID: "Please enter a valid email address",
		SEND_LINK: "Send Login Link",
		SUCCESS_TITLE: "Check Your Email",
		SUCCESS_DESCRIPTION:
			"We've sent a login link to your email address. Click the link to access the room.",
		ERROR_TITLE: "Something went wrong",
		ERROR_DESCRIPTION: "Failed to send login link. Please try again.",
		CANCEL: "Cancel",
	},
	START_DATE_TIME: "Start Date & Time",
	END_DATE_TIME: "End Date & Time",
	REVERT_TO_ORIGINAL: "Revert to Original",
	SELECTED_LANGUAGE: "Selected language",
	TRANSLATION_INFO: "Some transcripts have been translated from the original.",
	INVITE_GUEST: "Invite Guest",
	INVITE_GUEST_DESCRIPTION:
		"Invite guest user to the room by entering their name and email address",
	CREATED_BY: "Created By",
	VIEW_ALL: "View All",
	LOBBY: {
		LOBBY: "Lobby",
		WAITING_IN_LOBBY: "{name: string} is waiting in lobby",
		USERS_WAITING_IN_LOBBY: "Manage users currently waiting in the lobby.",
		SEND_INVITE: "Send Invite",
		ADMIT: "Admit",
		REJECT: "Reject",
		NO_PARTICIPANTS: "No Participants in the lobby.",
	},
	CLOSE: "Close",
	LOGIN_PAGE: {
		CAROUSEL_STORY_1:
			"Experience real-time transcription with advanced speaker recognition technology. Perfect for meetings, interviews, and conferences.",
		CAROUSEL_STORY_2:
			"High-contrast mode, customizable fonts, and multi-language support ensure everyone can use our platform effectively.",
		CAROUSEL_STORY_3:
			"Your conversations are protected with enterprise-grade security. Join thousands of professionals who trust uTranscribe.",
		CAROUSEL_STORY_4:
			"Choose your identification method below and start transcribing in seconds. No complex setup required.",
		CDCR_TEAM_TITLE: "Tech Unicorn Team",
		CDCR_TEAM_SUBTITLE: "Verified Staff Member",
		OR_CONTINUE_WITH: "or continue with",
		GUEST_ACCESS_SUBTITLE: "Not a member? Join using your Meeting ID",
		WELCOME_TO: "Welcome to",
		CHOOSE_IDENTIFICATION: "Please choose your identification",
		NEED_HELP: "Need help? Connect with our Support Desk.",
		CALL_SUPPORT: "Call 1-877-742-2135",
		EMAIL_SUPPORT: "Email support@courtroom.tech",
	},
	SIZES: "Sizes",
	DIAGNOSTICS: "Diagnostics",
	ROOM_BACKGROUND: "Room Background",
	NOT_AVAILABLE: "N/A",
	UNRECOGNIZED_SPEECH: "Unrecognized Speech",
	UNRECOGNIZED_SPEECH_TOOLTIP:
		"This transcript is not recognized. Please check the audio quality and try again.",
	UNDETECTED: "Undetected",
	MICROPHONE_QUALITY_WARNING:
		"Please check your microphone quality to improve accuracy or adjust your microphone distance",
	LOW_ACCURACY_WARNING: "Low Accuracy",
	UNKNOWN: "Unknown",
	TRANSCRIPTION_SETTINGS: {
		TRANSCRIPTION_SETTINGS: "Transcription Settings",
		MODE: "Mode",
		LIVE_TRANSCRIPTION: "Live Transcription",
		SEGMENTED_TRANSCRIPTION: "Segmented Transcription",
		FINAL_TRANSCRIPTION: "Final Transcription",
		LIVE_DESC:
			"See a live transcript of your own speech in a separate pane while speaking. The main pane shows the finalized transcript for all speakers.",
		SEGMENTED_DESC:
			"Display segmented temporary transcript in real time, updating automatically to the finalized version.",
		FINAL_DESC:
			"Display only the finalized transcript in the main pane. No live transcription is shown.",
		SPEED_VALUE: "Speed: {value:number}x",
		SPEED: "Speed",
		FONT_TEST:
			"UTranscribe is revolutionizing the way we capture and understand speech.",
		FONT_SIZE: "Font size",
		SPEED_DESC: "Transcription speed and delay",
		DELAY_DESC: "{speed:number}x speed = {delay:number} second delay",
	},
	NO_AUDIO: "No audio detected",
	NO_AUDIO_DESC:
		"Your microphone is unmuted but no audio is being detected. Please check your microphone settings or switch to another microphone.",
	NO_TRANSCRIPTION: "Transcriptions not generated",
	NO_TRANSCRIPTION_DESC:
		"Transcriptions are not being generated. Please refresh the page.",
	SCROLLING_PAUSED: "Auto-scrolling to bottom is paused",
	RESUME: "Resume",
} satisfies BaseTranslation;

export default en;
